const HTML_HINT = /<(p|h2|h3|ul|ol|li|strong|em|u|br|img|a)\b/i;
const TITLES = ["What it is", "Common signs", "How it is treated", "What you can do", "When to get help"];
const BACKEND = process.env.REACT_APP_BACKEND_URL;

const escapeHtml = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

/** Older handouts were plain text. Convert them the same way the server does. */
export function toHtml(body) {
  const text = String(body || "");
  if (!text.trim() || HTML_HINT.test(text)) return text;
  const out = [];
  let items = [];
  const flush = () => { if (items.length) { out.push(`<ul>${items.map((i) => `<li>${escapeHtml(i)}</li>`).join("")}</ul>`); items = []; } };
  text.trim().split(/\n\s*\n/).forEach((block) => {
    block.split("\n").map((l) => l.trim()).filter(Boolean).forEach((s) => {
      if (/^[-*\u2022]\s/.test(s)) { items.push(s.replace(/^[-*\u2022]\s*/, "")); return; }
      flush();
      const t = s.replace(/:$/, "");
      out.push(TITLES.includes(t) ? `<h3>${escapeHtml(t)}</h3>` : `<p>${escapeHtml(s)}</p>`);
    });
    flush();
  });
  return out.join("");
}

/** Plain words only, parsed in an inert document so nothing loads or runs. */
export function textOf(html) {
  const doc = new DOMParser().parseFromString(toHtml(html), "text/html");
  return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
}

export const absolutize = (html) => String(html || "").replace(/src="\/api\//g, `src="${BACKEND}/api/`)
  .replace(/<a (?![^>]*\btarget=)/gi, '<a target="_blank" rel="noopener noreferrer" ');
export const relativize = (html) => String(html || "").split(`src="${BACKEND}/api/`).join('src="/api/');
